/* eslint-disable */
export default {
  loginButton: 'Se connecter',
  signupButton: 'Nouvel utilisateur? Inscrivez-vous',
  version: 'Version',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
